<template>
    <v-container>
        <div style="background-color: rgb(230, 233, 242); padding-left: 20px; padding-right: 20px;">
            <h2 style="font-size: 2.5rem; color: rgb(0, 30, 67)">Glosario</h2>
            <div>
                <v-row>
                    <v-col cols="12" md="12" lg="12">
                        El glosario de <b style="color: rgb(0, 30, 67)">IDmaderas</b> es tu guía rápida para los términos clave en la identificación anatómica de maderas. 
                        Aquí encontrarás definiciones claras y concisas sobre aspectos como porosidad, parénquima, radios y otros elementos esenciales. Este recurso te ayudará a familiarizarte con la
                        terminología del <b style="color: rgb(0, 30, 67)">IDmaderas</b> y mejorar tus habilidades de identificación. 
                    </v-col>
                </v-row>
            </div>
        </div>
        <br>
            <div>
            <!-- Campo de búsqueda -->
            <v-text-field v-model="searchTerm" label="Buscar término..." outlined dense hide-details>
                <template v-slot:append>
                <div style="color: white; background-color: rgb(0, 124, 186); height: 100%; margin-right: -12px; margin-top: -7px; padding: 10px">
                    <v-icon style="color: white;">search</v-icon>Buscador
                </div>
                </template>
            </v-text-field>
            <br>

            <div>
            <!-- Sección 1: Conceptos Generales -->
            <details :open="isSectionOpen('Conceptos Generales')">
                <summary>
                <p><b>1. CONCEPTOS GENERALES</b></p>
                </summary>
                <ul>
                <li v-for="(item, index) in filteredGlossary" :key="index" v-if="item.category === 'Conceptos Generales'">
                    <b>{{ item.term }}</b><br> {{ item.definition }}
                    <v-img 
                    v-if="item.images && item.images.length > 0" 
                    :src="getImageSrc(item.images[0])" 
                    contain 
                    class="align-end text-white"
                    :style="{ 'max-width': '180vh', 'max-height': '25vh' }"
                    ></v-img><br>
                    <ul v-if="item.subdefinitions">
                    <li v-for="(subitem, subindex) in item.subdefinitions" :key="subindex">
                        <b>{{ subitem.subterm }}:</b> {{ subitem.subdefinition }}
                        <v-img 
                        v-if="subitem.images && subitem.images.length > 0" 
                        :src="getImageSrc(subitem.images[0])" 
                        contain 
                        class="align-end text-white"
                        :style="{ 'max-width': '180vh', 'max-height': '25vh' }"
                        ></v-img><br>
                    </li>
                    </ul>
                </li>
                </ul>
            </details>

            <!-- Sección 2: Términos Base -->
            <details :open="isSectionOpen('Terminos Base Caracteristicas Generales')">
                <summary>
                    <p><b>2. TÉRMINOS BASE</b></p>
                </summary>
                <details :open="isSectionOpen('Terminos Base Caracteristicas Generales')">
                    <summary>
                        <p><b>2.1. CARACTERÍSTICAS GENERALES</b></p>
                    </summary>
                    <ul>
                        <li v-for="(item, index) in filteredGlossary" :key="index" v-if="item.category === 'Terminos Base Caracteristicas Generales'">
                        <b>{{ item.term }}</b><br> {{ item.definition }}
                        <v-img 
                            v-if="item.images && item.images.length > 0" 
                            :src="getImageSrc(item.images[0])" 
                            contain 
                            class="align-end text-white"
                            :style="{ 'max-width': '180vh', 'max-height': '25vh' }"
                        ></v-img><br>
                        <ul v-if="item.subdefinitions">
                            <li v-for="(subitem, subindex) in item.subdefinitions" :key="subindex">
                            <b>{{ subitem.subterm }}:</b> {{ subitem.subdefinition }}
                            <v-img 
                                v-if="subitem.images && subitem.images.length > 0" 
                                :src="getImageSrc(subitem.images[0])" 
                                contain 
                                class="align-end text-white"
                                :style="{ 'max-width': '180vh', 'max-height': '25vh' }"
                            ></v-img><br>
                            </li>
                        </ul>
                        </li>
                    </ul>
                </details>
                
                <details :open="isSectionOpen('Terminos Base Caracteristicas Macroscopicas')">
                    <summary>
                        <p><b>2.2. CARACTERISTICAS MACROSCÓPICAS (CLAVES)</b></p>
                    </summary>
                    <ul>
                        <li v-for="(item, index) in filteredGlossary" :key="index" v-if="item.category === 'Terminos Base Caracteristicas Macroscopicas'">
                        <b>{{ item.term }}</b><br> {{ item.definition }}
                        <v-img 
                            v-if="item.images && item.images.length > 0" 
                            :src="getImageSrc(item.images[0])" 
                            contain 
                            class="align-end text-white"
                            :style="{ 'max-width': '180vh', 'max-height': '25vh' }"
                        ></v-img><br>
                        <ul v-if="item.subdefinitions">
                            <li v-for="(subitem, subindex) in item.subdefinitions" :key="subindex">
                            <b>{{ subitem.subterm }}:</b> {{ subitem.subdefinition }}
                            <v-img 
                                v-if="subitem.images && subitem.images.length > 0" 
                                :src="getImageSrc(subitem.images[0])" 
                                contain 
                                class="align-end text-white"
                                :style="{ 'max-width': '180vh', 'max-height': '25vh' }"
                            ></v-img><br>
                            </li>
                        </ul>
                        </li>
                    </ul>
                    </details>
                </details>
            </div>
      </div>      
    </v-container>
  </template>    
<script>    
    export default {
    name: 'HelloWorld',

    data() {
        return {
            searchTerm: '',
            glossary: [
                {
                    term: "1.1. NOMBRE COMÚN",
                    definition: "En IDmaderas, nombre que responde al nombre comercial de la Lista Oficial de especies forestales del SERFOR 2023. Sin embargo, este puede cambiar entre regiones del Perú.",
                    category: "Conceptos Generales"
                },
                {
                    term: "1.2. NOMBRE INTERNACIONAL",
                    definition: "Nombre que se utiliza a nivel mundial para el comercio internacional de la especie de madera.",
                    category: "Conceptos Generales"
                },
                {
                    term: "1.3. NOMBRE CIENTÍFICO",
                    definition: "Nombre en latín que se da formalmente a una especie.",
                    category: "Conceptos Generales"
                },
                {
                    term: "1.4. FAMILIA",
                    definition: "Grupo de géneros que poseen caracteres anatómicos comunes.",
                    category: "Conceptos Generales"
                },
                {
                    term: "1.5. IDENTIFICACIÓN ANATÓMICA",
                    definition: "Proceso para reconocer a qué especie pertenece una muestra de madera en base de sus características anatómicas macroscópicas poros, radios, fibras, parénquima, y otros.  ",
                    category: "Conceptos Generales"
                },
                {
                    term: "1.6. IDENTIFICACIÓN DENDROLÓGICA",
                    definition: "Consiste en reconocer a qué especie pertenece un árbol, en base a sus características externas como, hojas, flores, frutos, corteza y sustancias que segregan tales como látex, gomas y resinas.",
                    category: "Conceptos Generales"
                },
                {
                    term: "1.7. CORTES DE MADERA",
                    definition: "Es la sección o superficie que resulta al cortar una pieza de madera en diferentes planos. Puede ser, transversal y longitudinal (radial y tangencial).",
                    images: ['glosario7.png'],
                    category: "Conceptos Generales", 
                    subdefinitions: [
                        {
                            subterm: "1.7.1. CORTE TRANSVERSAL (TR)",
                            subdefinition: "Corte perpendicular al eje longitudinal del tronco. Es el extremo de cualquier pieza de madera, donde se visualiza la albura, corteza, duramen, anillos de crecimiento y otros elementos macroscópicos como la porosidad, el tipo de poros y el parénquima.",
                            images: ['glosario7_1.jpg'], 
                        },
                        {
                            subterm: "Corteza",
                            subdefinition: "Son los tejidos que se encuentran fuera del cilindro leñoso, generalmente se pueden distinguir dos: una interna (viva) llamada corteza interna o floema y una externa (muerta) llamada también ritidoma, súber o corcho."
                        },
                        {
                            subterm: "Albura",
                            subdefinition: "Parte de la madera que contiene células vivas y materiales de reserva; ubicada inmediatamente después de la corteza y entre el duramen, generalmente de color más claro que el duramen."
                        },
                        {
                            subterm: "Duramen",
                            subdefinition: "Parte de la madera biológicamente inactiva y que generalmente se diferencia de la albura por su color más oscuro. En él pueden depositar resinas y otros materiales que lo hacen más oscuro."
                        },
                        {
                            subterm: "Anillos de crecimiento",
                            subdefinition: "Capas de crecimiento concéntricas, que se observan en la sección transversal. Son muy marcados en especies maderables que crecen en climas templados y poco marcados o no diferenciados en especies tropicales."
                        },
                        {
                            subterm: "1.7.2. CORTE RADIAL (RD)",
                            subdefinition: "Corte que se realiza paralelo a los radios y perpendicular a los anillos de crecimiento. En esta sección también se observan características claves que sirven para la identificación de especies."
                        },
                        {
                            subterm: "1.7.3. CORTE TANGENCIAL (TG)",
                            subdefinition: "Sección de la madera obtenida mediante el corte paralelo al eje longitudinal del tronco y tangente a los anillos de crecimiento. En esta se observa normalmente la madera a simple vista para describir sus características generales, tales como color, textura, brillo y veteado."
                        },
                        {
                            subterm: "1.7.4. CORTE LONGITUDINAL (LG):",
                            subdefinition: "Denominación general de los tipos de corte tangencial, radial y oblicuo (corte intermedio entre el tangencial y radial)."
                        },
                    ]
                },
                {
                    term: "2.1.1. COLOR",
                    definition: "Originado por sustancias químicas depositadas en el interior de las células. En la albura, el color es poco significativo para la identificación de las maderas, ya que suele tener tonalidades muy parecidas en las distintas clases de maderas, como los colores blancos, amarillo, rojo, marrón. En el duramen, el color es muy variable, por ello su utilidad en la identificación de las distintas clases de madera.",
                    category: "Terminos Base Caracteristicas Generales"
                },
                {
                    term: "2.1.2. OLOR",
                    definition: "Característica originada por sustancias químicas presentes en el interior de madera. No todas las especies presentan olores característicos.",
                    category: "Terminos Base Caracteristicas Generales"
                },
                {
                    term: "2.1.3. SABOR",
                    definition: "Característica originada por sustancias químicas en el interior de la madera. No todas las especies presentan un sabor característico.",
                    category: "Terminos Base Caracteristicas Generales"
                },
                {
                    term: "2.1.4. VETEADO",
                    definition: "Son las figuras que presentan las maderas en su superficie longitudinal; debido a la disposición de los elementos que constituyen su estructura.",
                    category: "Terminos Base Caracteristicas Generales",
                    subdefinitions: [
                        {
                            subterm: "ARCOS SUPERPUESTOS",
                            subdefinition: "Figura que se presenta en la sección longitudinal tangencial, producida por los anillos de crecimiento. Se observa en forma de arcos dispuestos uno sobre otro.",
                            images: ['glosario2_4.jpg'], 
                        },
                        {
                            subterm: "JASPEADO",
                            subdefinition: "Tipo de veteado que se presenta en la sección longitudinal radial y es producido por los radios anchos o gruesos cuando son observados en corte transversal.",
                            images: ['glosario14.jpg'],
                        },
                        {
                            subterm: "SATINADO",
                            subdefinition: "Veteado observado en la sección longitudinal radial en forma de bandas producido por el alto brillo y el grano entrecruzado.",
                            images: ['glosario21.jpg'],
                        },
                    ],
                },               
                {
                    term: "2.1.5. POROSIDAD",
                    definition: "Se refiere al tipo de dispersión de los poros, en base al tamaño y la forma en que se encuentran distribuidos dentro de los anillos de crecimiento.",
                    category: "Terminos Base Caracteristicas Generales",
                    subdefinitions: [
                        {
                            subterm: "Porosidad difusa",
                            subdefinition: "Cuando los poros (vasos) se presentan dispersos con tamaño aproximadamente uniforme en el interior de los anillos de crecimiento.",
                            images: ['glosario17_1.jpg'],
                        },
                        {
                            subterm: "Porosidad circular",
                            subdefinition: "Cuando se observa la presencia de poros de mayor diámetro en el leño temprano con disminución abrupta del diámetro de los poros en el leño tardío, formando un anillo bien definido.",
                            images: ['glosario17_2.jpg'],
                        },
                    ]
                },
                {
                    term: "2.2.1. POROS",
                    definition: "Término convencional para designar la sección transversal de un vaso. Los poros, toman el aspecto de pequeños agujeros en la sección transversal de la madera (extremos de las tablas).",
                    images: ['glosario18.jpg'],
                    category: "Terminos Base Caracteristicas Macroscopicas",
                    subdefinitions: [
                        {
                            subterm: "Poros solitarios",
                            subdefinition: "Poros rodeados por otro tipo de elemento anatómico.",
                        },
                        {
                            subterm: "Poros múltiples radiales",
                            subdefinition: "Grupo de poros juntos, generalmente achatados",
                        },
                    ]
                },
                {
                    term: "2.2.2. PARÉNQUIMA",
                    definition: "Tejido blando y más claro que las fibras de la madera. Se orienta a lo Largo del eje del tronco y es visible en la sección transversal.",
                    category: "Terminos Base Caracteristicas Macroscopicas",
                },
                {
                    term: "2.2.2.1. PARÉNQUIMA APOTRAQUEAL",
                    definition: "Tejido que se encuentra separado de los poros.",
                    category: "Terminos Base Caracteristicas Macroscopicas",
                    subdefinitions: [
                        {
                            subterm: "Difuso",
                            subdefinition: "Las células de parénquima, separadas entre sí, se distribuyen irregularmente en el tejido leñoso.",
                        },
                        {
                            subterm: "Difuso en agregados",
                            subdefinition: "Células de parénquima que tienden a agruparse en cortas líneas tangenciales que se extienden de radio a radio.",
                            images: ['glosario16_1.jpg'],
                        },
                    ]
                },
                {
                    term: "2.2.2.2. PARÉNQUIMA PARATRAQUEAL",
                    definition: "Tejido que se encuentra junto a los poros.",
                    category: "Terminos Base Caracteristicas Macroscopicas",
                    subdefinitions: [
                        {
                            subterm: "Vasicéntrico",
                            subdefinition: "Parénquima que rodea totalmente a un vaso, de ancho variable.",
                            images: ['glosario16_2.jpg'],
                        },
                        {
                            subterm: "Aliforme",
                            subdefinition: "Tipo de parénquima que posee extensiones laterales que semejan alas.",
                            images: ['glosario16_3.jpg'],
                        },
                        {
                            subterm: "Aliforme confluente",
                            subdefinition: "Parénquima que rodea los poros y se une al parénquima de otros poros.",
                            images: ['glosario16_4.jpg'],
                        },
                    ]
                },
                {
                    term: "2.2.2.3. PARÉNQUIMA EN BANDAS ",
                    definition: "Tejido que se encuentra junto a los poros.",
                    category: "Terminos Base Caracteristicas Macroscopicas",
                    subdefinitions: [
                        {
                            subterm: "Bandas delgadas",
                            subdefinition: "En forma de franjas o bandas concéntricas de parénquima estrecha, por lo general visibles con lupa de 10x.",
                            images: ['glosario16_5.jpg'],
                        },
                        {
                            subterm: "Bandas anchas",
                            subdefinition: "En forma de franjas o bandas concéntricas de parénquima gruesa, visibles a simple vista.",
                            images: ['glosario16_6.jpg'],
                        },
                        {
                            subterm: "Reticulado",
                            subdefinition: "Término descriptivo para el diseño semejante a una cuadrícula que forman en la sección transversal los radios y las bandas.",
                            images: ['glosario16_7.jpg'],
                        },
                        {
                            subterm: "Bandas marginales",
                            subdefinition: "Tejido que hace referencia a bandas angostas de parénquima que se ubican al final de los anillos de crecimiento, delimitándolos.",
                            images: ['glosario16_8.jpg'],
                        },
                    ]
                },
                {
                    term: "2.2.3. TEXTURA",
                    definition: "Característica dada por el tamaño, distribución y volumen proporcional de los elementos leñosos que componen la madera (poros, parénquima y fibras). La textura puede ser fina, media y gruesa.",
                    category: "Terminos Base Caracteristicas Macroscopicas",
                    subdefinitions: [
                        {
                            subterm: "Textura gruesa",
                            subdefinition: "Elementos constitutivos grandes. Poros con diámetro tangencial grande de más de 250 micras, radios leñosos grandes y parénquima abundante.",
                        },
                        {
                            subterm: "Textura fina",
                            subdefinition: "Elementos constitutivos pequeños. Poros menores de 150 micras de diámetro tangencial, parénquima escaso y abundante tejido fibroso.",
                        },
                        {
                            subterm: "Textura mediana",
                            subdefinition: "Intermedia entre la gruesa y la fina.",
                        },
                    ]
                },
                {
                    term: "2.2.4. INCLUSIONES",
                    definition: "Sustancias que cubren los poros parcial o totalmente; pueden afectar el secado, preservación y aserrío de las maderas. En algunos casos se aprecia con claridad en la sección transversal y en otros en la sección longitudinal.",
                    category: "Terminos Base Caracteristicas Macroscopicas",
                    subdefinitions: [
                        {
                            subterm: "TILOSIS",
                            subdefinition: "Células de parénquima que tapan los poros. Se aprecia en la sección transversal.",
                            images: ['glosario13_1.jpg'],
                        },
                        {
                            subterm: "GOMAS",
                            subdefinition: "Material orgánico, generalmente de color oscuro, distinguible en la sección longitudinal.",
                            images: ['glosario13_2.jpg'],
                        },
                        {
                            subterm: "SÍLICE",
                            subdefinition: "Compuesto mineral presente en algunas especies, se visualizan como puntos blancos en la sección longitudinal. Desgasta rápidamente el filo de las herramientas.",
                            images: ['glosario13_3.jpg'],
                        },
                        {
                            subterm: "LAPACHOL",
                            subdefinition: "Material orgánico, generalmente de color verdoso o amarillento, que se aprecia en el interior de los vasos en la sección longitudinal. ",
                            images: ['glosario13_4.jpg'],
                        }
                    ]
                },
                {
                    term: "2.2.5. RADIOS",
                    definition: "Tipo de tejido parenquimatoso, caracterizado por estar orientado con dirección de la corteza hacia la médula. En la sección transversal se aprecian como líneas paralelas de tejido de tonalidad clara.",                    
                    category: "Terminos Base Caracteristicas Macroscopicas",
                    images: ['glosario2_2_5.jpg'],                    
                    subdefinitions: [
                        {
                            subterm: "Radios estratificados",
                            subdefinition: "Se aprecian como segmentos alineados de tejido de tonalidad clara en la sección tangencial de la madera.",
                            images: ['glosario19.jpg'],
                        },
                        {
                            subterm: "Radios no estratificados",
                            subdefinition: "Se aprecian como segmentos no alineados de tejido de tonalidad clara en la sección tangencial de la madera.",
                        },
                        {
                            subterm: "Ancho de radios",
                            subdefinition: "Se refiere al espesor de los radios, se denominan radios anchos cuando son visibles a simple vista, medianos cuando son ligeramente visibles y finos cuando para observarlos se requiere una lupa de 10x.",
                        },
                    ]
                },
            ],
            filteredItems: [],
        };
    },

    computed: {
        filteredGlossary() {
            const searchTermNormalized = this.normalizeString(this.searchTerm).toLowerCase();

            return this.glossary.filter(item => {
                const termNormalized = this.normalizeString(item.term).toLowerCase();
                const matchTerm = termNormalized.includes(searchTermNormalized);

                const matchSubdefinitions = item.subdefinitions && 
                item.subdefinitions.some(sub => {
                    const subtermNormalized = this.normalizeString(sub.subterm).toLowerCase();
                    return subtermNormalized.includes(searchTermNormalized);
                });

                return matchTerm || matchSubdefinitions;
            });
        }
    },

    methods: {
        
        getImageSrc(filename) {
            try {
                // Usamos require para importar la imagen desde src/assets
                return require(`../assets/${filename}`);
            } catch (error) {
                console.error(`No se pudo cargar la imagen ${filename}:`, error);
                return ''; // Si no se encuentra la imagen, devolvemos una cadena vacía
            }
        },
        isSectionOpen(category) {
            return this.filteredGlossary.some(item => item.category === category);
        },
        // Función para eliminar acentos y normalizar el texto
        normalizeString(str) {
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        },
    },
};
</script>
<style>
    p {
    font-family: 'Heebo', sans-serif !important;
        font-size: 17px;        
        line-height: 1.6em;
    }
    h1 {
    font-family: 'Heebo', sans-serif !important;
        font-size: 2.5rem;
    }
    h2 {
    font-family: 'Sofia Sans', sans-serif !important;
    }
    h3 {
    font-family: 'Sofia Sans', sans-serif !important;
    }
    h5 {
        font-family: 'Sofia Sans', sans-serif !important;
        font-size: 1.25rem;
    }
    details { 
        background-color: #f6f8fa;
        width: 100%;
        margin-bottom: 1rem;   
        border-radius: 8px;  
        border: 1px solid #d8e0e9;
        color: #364f6b;
        position: relative;  
        padding-top: 0px;
    }
    details[open] summary {
        border-bottom: 1px solid #aaa;
        margin-bottom: 0.5em;
    }
    details summary {  
        font-weight: 400;
        font-size: 1.25rem;
        padding: 1rem;
        cursor: pointer;
        list-style: none;
    }
    details summary::before {
        content: "▶"; /* Flecha hacia la derecha */
        font-size: 1.5rem;
        line-height: 1.5rem;
        color: #364f6b;
        position: absolute;
        left: 97%; /* Ajusta el espacio entre la flecha y el texto */
    }
    details[open] summary::before {
        content: "▼"; /* Flecha hacia abajo cuando details está abierto */
    }
    
</style>